<div class="container-fluid" style="padding-left: 5px;">
    <!-- paddLeft25 -->

    <!-- Header -->
    <div class="col-md-12 col-lg-12 col-12 paddLeft25" style="padding: 15px; padding-bottom: 0px;">
        <div class="col-md-7 col-lg-7 col-12" style="display: inline-block; padding: 0px;">
            <span class="mobView" style="font-size: 22px; margin-right: 10px; display: inline-block;"
                (click)="backBtn()"><i class="fa fa-chevron-left"></i></span>
            <h2 style="display: inline-block; font-size: 25px; height: 33;">{{title}}</h2>
        </div>
       
        <div class="col-md-5 col-lg-5 col-3 webView" style="display: inline-block; padding: 0px; text-align: right;">
            <div *ngIf="isshowRefresh" class="btn btn-orange brdrRadius3" style="line-height: inherit; padding: 2px 8px; margin-right: 10px;" (click)="RefreshPage()" title="Refresh">
                <i class="fa fa-refresh"></i>
            </div>
            <div class="btn-orange font13 brdrRadius3" style="padding: 4px 12px 4px; margin-top: 10px; margin-right: 10px;"
                (click)="openItemSelect(selectItem)">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="margin-right: 5px;"></i>Select More Items
            </div>
            <span class="btn-darkBlue font13 brdrRadius3" style="font-size: 13px; display: inline-block; padding: 4px 12px 4px;"
                (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
            </span>
        </div>
        <!-- Store Transfer -->
    </div>

    <div class="col-md-12 col-lg-12 col-12 paddLeft5" style="display: flex; padding: 0px;">

        <div class="col-md-10 col-lg-10 col-12" style="padding: 0px; display: inline-block;">
            <div class="row" style="margin: 0px;">
                <div class="col-md-12" style="padding: 0px;">
                    
                    <div *ngIf="isStoreTransfer" style="margin-top: 10px; padding-left: 21px; padding-right: 15px;">
                        <div class="darkBlueBadge disblk mrgRgt10 font13 brdrRadius3" style="display: inline-block; height: 35px !important; position: relative; bottom: 2px;"> 
                            <i class="fa fa-shopping-cart" style="margin-right: 5px; font-size: 13px;"></i> 
                            From {{frmStore.name}}
                        </div>
                        <div class="disblk mrgRgt10">
                            <div class="darkBlueBadge mrgTop10 brdrRadius3" style="display: inline-block; cursor: pointer; height: 35px !important;">
                                <div class="font13" style="display: inline-block;" (click)="selectStore(storeSelect)"><i
                                        class="zmdi zmdi-city-alt" style="margin-right: 5px; font-size: 13px;"></i> To
                                    {{toStore.name}} <i class="fa fa-pencil"
                                        style="margin-left: 5px; font-size: 12px;"></i></div>
                            </div>
                        </div>
                        <!-- <div class="wid15" style="display: inline-block; position: relative;">
                            <div class="darkBlueBadge disblk mrgRgt10 mrgTop10"> 
                                <i class="zmdi zmdi-file-text" style="margin-right: 5px; font-size: 17px;"></i> 
                                <span style="display: inline-block;">Ref No.</span>
                                <span class="wid45p" style="display: inline-block; margin-left: 10px;">
                                    <input type="text" class="form-control" [(ngModel)]="xnCode" style="background-color: inherit; height: 20px; padding: 2px;">
                                    <span *ngIf="isShowPrevNo" style="color: #777; font-size: 13px;">(Prev: {{prevXnCode}})</span>
                                </span>
                            </div> 
                            <span *ngIf="isShowPrevNo" style="position: absolute; top: 98%; left: 5%; color: #777; font-size: 13px; width: 100%;">Prev Ref No. : {{prevXnCode}}</span>  
                        </div> -->
                        <div class="darkBlueBadge disblk mrgRgt10 brdrRadius3"
                            style="display: inline-block; margin-top: 10px; padding-right: 0px; position: relative; height: 35px !important;">
                            <div class="col-md-12" style="padding: 0px;">

                                <!-- <span style="display: inline-block;"> {{ isDispatch ? 'Delivery Chalan' : isIssueDirect || isStoreTransfer || isReturnDirect || isGNR ? 'Ref No.' : ''}}</span> -->
                                <div class="{{ isShowPrevNo ? 'col-md-7' : 'col-md-12' }}"
                                    style="display: inline-block; padding: 0px;">
                                    <i class="zmdi zmdi-file-text" style="margin-right: 5px; font-size: 13px;"></i>
                                    <span style="display: inline-block;font-size: 13px;">Ref No.</span>
                                    <span>
                                        <input type="text" class="form-control" [(ngModel)]="xnCode"
                                            style="background-color: inherit !important; height: 20px; padding: 2px; display: inline-block; margin-left: 10px; width: 50%;">
                                    </span>
                                </div>
                                <div *ngIf="isShowPrevNo" class="col-md-5"
                                    style="display: inline-block; padding: 0px; width: fit-content;">
                                    <span style="color: #777; font-size: 13px; margin-left: 5px;">(Prev:
                                        {{prevXnCode}})</span>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div style="padding-left: 21px; padding-right: 15px;">
                        <div *ngIf="!isStoreTransfer && !isFromInvList && !isJobwork" class="darkBlueBadge disblk mrgRgt10 font13 brdrRadius3"
                            style="display: inline-block; margin-top: 10px; padding: 4px 13px;"> 
                                <i class="fa fa-shopping-cart" style="margin-right: 5px;"></i> 
                                {{frmStore.name}}
                        </div>

                        <!-- From Jobwork Out -->
                        <div *ngIf="isJobwork" style="display: inline-block;">
                            <div class="darkBlueBadge disblk mrgRgt10 font13 brdrRadius3" style="display: inline-block; margin-top: 10px; padding: 4px 13px;"> 
                                <i class="fa fa-shopping-cart" style="margin-right: 5px; font-size: 13px;"></i> 
                                From {{frmStore.name}}
                            </div>

                            <div (click)="id == 7 ? openCompModal(1) : ''" class="darkBlueBadge disblk mrgRgt10 brdrRadius3" style="display: inline-block; padding: 4px 13px; margin-top: 10px; font-size: 13px; cursor: {{ id == 7 ? 'pointer' : '' }};"> 
                                <i class="fa fa-industry" style="margin-right: 5px; font-size: 13px;"></i> 
                                {{ isCustSelected ? customer.name : 'Select Supplier' }} 
                                <i *ngIf="id == 7" class="fa fa-pencil" style="margin-left: 5px; font-size: 12px;"></i>
                            </div>
                            <div (click)="selectStore(storeSelect)" class="darkBlueBadge disblk mrgRgt10 brdrRadius3" style="display: inline-block; padding: 4px 13px; margin-top: 10px; cursor: pointer;font-size: 13px;">
                                <i class="zmdi zmdi-city-alt" style="margin-right: 5px; font-size: 13px;"></i> 
                                To {{toStore.name}} 
                                <i class="fa fa-pencil" style="margin-left: 5px; font-size: 12px;"></i>                                
                            </div>
                        </div>


                        <!-- From Invoice List -->
                        <div *ngIf="!isStoreTransfer && isFromInvList" class="darkBlueBadge disblk mrgRgt10 font13 brdrRadius3"
                            style="display: inline-block; margin-top: 10px; padding: 4px 13px; cursor: pointer;" (click)="openFromStore(storeSelect)"> <i class="zmdi zmdi-city-alt"
                                style="margin-right: 5px;"></i> 
                                {{frmStore.name}}
                            <i class="fa fa-pencil" style="margin-left: 5px; font-size: 12px;"></i>
                        </div>

                        <br *ngIf="!isStoreTransfer" class="mobView" />

                        <div *ngIf="isGNR" (click)="openCompModal(1)" class="darkBlueBadge disblk mrgRgt10 brdrRadius3"
                            style="display: inline-block; padding: 4px 13px; margin-top: 10px; cursor: {{isFromInvList ? '' : '' }};font-size: 13px;"> <i
                                class="fa fa-industry" style="margin-right: 5px; font-size: 13px;"></i> 
                                {{ isCustSelected ? customer.name : (isGNR ? 'Select Customer / Supplier' : (type == 'DCRN' ? 'Select Customer' : 'Select Supplier'))}} <i class="fa fa-pencil" *ngIf="!isFromInvList"
                                style="margin-left: 5px; font-size: 12px;"></i></div>

                        <br *ngIf="isGNR" class="mobView" />

                        <div *ngIf="isDispatch && !isFromCashMemo" (click)="openCompModal(2)" class="darkBlueBadge disblk mrgRgt10 brdrRadius3"
                        style="display: inline-block; padding: 4px 13px; margin-top: 10px; cursor: {{isFromInvList ? '' : 'pointer'}}; font-size: 13px;"> 
                            <i class="fa fa-industry" style="margin-right: 5px; font-size: 13px;"></i> 
                            {{ isCustSelected ? customer.name : (isDispatch ? 'Select Customer / Supplier' : (type == 'DDBN' ? 'Select Supplier' : 'Select Customer'))}}
                            <i *ngIf="!isFromInvList" class="fa fa-pencil" style="margin-left: 5px; font-size: 12px;"></i>
                        </div>
                        
                        <div *ngIf="isDispatch && isFromCashMemo" class="darkBlueBadge disblk mrgRgt10 brdrRadius3"
                        style="display: inline-block; padding: 4px 13px; margin-top: 10px; cursor: pointer; font-size: 13px;"> 
                            <i class="fa fa-industry" style="margin-right: 5px; font-size: 13px;"></i> 
                            <span>Customer :</span> <span style="font-weight: bold; padding-left: 3px;">{{customer.name}}</span> <!--{{ isCustSelected ?customer.name : 'Select Customer'}} -->
                            <i *ngIf="!isFromInvList" class="fa fa-pencil" style="margin-left: 5px; font-size: 12px;"></i>
                        </div>

                        <br *ngIf="isDispatch" class="mobView" />

                        <div *ngIf="isIssueDirect || isReturnDirect" (click)="openSelectExecutive()"
                            class="darkBlueBadge disblk mrgRgt10 font13 brdrRadius3"
                            style="display: inline-block; margin-top: 10px; padding: 4px 13px; cursor: pointer;font-size: 13;"> <i
                                class="fa fa-user" style="margin-right: 5px; font-size: 13px;"></i> {{ executive.id == 0 
                            ? 'Select Executive' : executive.name }} <i class="fa fa-pencil"
                                style="margin-left: 5px; font-size: 12px;"></i></div>

                        <br *ngIf="isIssueDirect || isReturnDirect" class="mobView" />
                        <div *ngIf="!isStoreTransfer" class="darkBlueBadge disblk mrgRgt10 brdrRadius3"
                            style="display: inline-block; margin-top: 10px; padding: 4px 13px; position: relative; font-size: 13px;">
                            <div class="col-md-12" style="padding: 0px;">

                                <!-- <span style="display: inline-block;"> {{ isDispatch ? 'Delivery Chalan' : isIssueDirect || isStoreTransfer || isReturnDirect || isGNR ? 'Ref No.' : ''}}</span> -->
                                <div class="{{ isShowPrevNo ? 'col-md-7' : 'col-md-12' }}"
                                    style="display: inline-block; padding: 0px;">
                                    <i class="zmdi zmdi-file-text" style="margin-right: 5px; font-size: 13px;"></i>
                                    <span style="display: inline-block;font-size: 13px;">Ref No.</span>
                                    <span>
                                        <input type="text" class="form-control" [(ngModel)]="xnCode"
                                            style="background-color: inherit !important; height: 20px; padding: 2px; display: inline-block; margin-left: 10px; width: 50%;">
                                    </span>
                                </div>
                                <div *ngIf="isShowPrevNo" class="col-md-5"
                                    style="display: inline-block; padding: 0px; width: fit-content;">
                                    <span style="color: #777; font-size: 13px; margin-left: 5px;">(Prev:
                                        {{prevXnCode}})</span>
                                </div>
                            </div>
                        </div>

                        <!-- <div *ngIf="!isStoreTransfer" class="darkBlueBadge disblk mrgRgt10 {{ isShowPrevNo ? 'wid46' : 'wid28'}}" style="display: inline-block; margin-top: 10px; padding-right: 0px; position: relative;"> 
                            <i class="zmdi zmdi-file-text" style="margin-right: 5px; font-size: 17px;"></i> 
                            
                            <span style="display: inline-block;">Ref No.</span>
                            <span>
                                <input type="text" class="form-control" [(ngModel)]="xnCode" style="background-color: inherit !important; height: 20px; padding: 2px; display: inline-block; width: {{ isShowPrevNo ? '30%' : '42%'}}; margin-left: 10px;">
                            </span>
                            <span *ngIf="isShowPrevNo" style="color: #777; font-size: 13px; margin-left: 5px;">(Prev: {{prevXnCode}})</span>
                        </div> -->

                    </div>
                </div>

                <div class="col-md-2 webView" style="padding: 0px; text-align: right; display: none;">
                    <div style="padding-left: 0px; padding-right: 0px;">
                        <div class="btn-yellow brdrRadius3"
                            style="padding: 4px 12px 4px; font-size: 15px; margin-top: 10px; position: relative; right: 12%;"
                            (click)="openItemSelect(selectItem)">
                            <i class="zmdi zmdi-plus" aria-hidden="true" style="margin-right: 5px;"></i>Add Items
                        </div>
                    </div>
                </div>

                <div class="col-md-2 mobView" style="text-align: left; padding-left: 21px;">
                    <div style="padding-left: 0px; padding-right: 0px; {{isShowPrevNo ? '' : ''}}">
                        <div class="orangeButton font13" style="padding: 4px 12px 4px; margin-top: 10px;"
                            (click)="openItemSelect(selectItem)">
                            <i class="zmdi zmdi-plus" aria-hidden="true" style="margin-right: 5px;"></i>Add Items
                        </div>
                    </div>
                </div>
            </div>
            <!-- Body -->
            <div class="row" style="margin: 0px; margin-top: 15px; padding-left: 5px;">
                <div class="col-md-12 col-lg-12 col-12 mobView" style="padding: 0px;">
                    <div class="col-md-12 col-lg-12 col-12" *ngFor="let i of items; let l = last;"
                        style="background: #FFF; padding: 10px 15px 10px 15px; border-top: 10px solid #F8F8F8; {{ l ? 'border-bottom: 10px solid #F8F8F8;' : '' }} font-size: 14px;">
                        <div class="col-md-9 col-lg-9 col-9 font13"
                            style="padding: 0px; display: inline-block; color: #444; font-weight: bold;">
                            {{i.ItemName}}
                        </div>
                        <div class="col-md-3 col-lg-3 col-3"
                            style="padding: 0px; display: inline-block; text-align: right;">
                            <span class="wid60 font13" style="display: inline-block;"><input class="form-control"
                                    type="text" placeholder="Qty" [(ngModel)]="i.transferQty"
                                    (change)="getTransferQty()" (keyup)="prcisionCheck(i);"
                                    style="text-align: right; height: 20px; position: relative; bottom: 1px;"></span>
                            <span> {{i.SKU}}</span>
                        </div>
                        <div class="col-md-9 col-lg-9 col-9 font13"
                            style="padding: 0px; display: inline-block; color: #777777; position: relative;">
                            <div class="font12"># {{i.ItemCode}}</div>
                        </div>
                        <div class="col-md-3 col-lg-3 col-3 font13"
                            style="padding: 0px; display: inline-block; text-align: right; color: #777777;">
                            <span class="font12"> {{i.StoreBatches.length > 0 ? i.StoreItemQty : i.CurrQty}}
                                {{i.SKU}}</span>
                        </div>
                        <div *ngIf="i.hasBatches && id != 2 && id != 7 && id != 8" class="col-md-12 col-lg-12 col-12" style="padding: 0px; text-align: right;margin-left: 5px;">
                            <div *ngIf="i.hasBatches" class="label darkdarkBlueBadge font13 brdrRadius3"
                            style="display: inline-block; margin-top: 10px; padding: 5px 10px"
                            (click)="openBatchSelectionMdl(i, in)"><i class="{{i.Batches.length > 0 ? 'fa fa-pencil' : 'zmdi zmdi-plus' }}" style="margin-right:5px;"></i>Batches
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div class="col-md-12 col-lg-12 col-12 webView">
                    <table class="table ngTable bzMatTbl shadow brdrRadius3"
                        style="width: 110%; margin-bottom: 10px; background-color: white;">
                        <thead>
                            <tr>
                                <th style="width: 200px; padding-left: 10px; font-size: 13px; border-top: none;">Item</th>
                                <th style="width: 150px; font-size: 13px;">Code</th>
                                <th style="width: 100px; font-size: 13px;">Qty</th>
                               
                                <th style="width: 100px; text-align: right; font-size: 13px;"
                                    *ngIf="id == 1 || id == 2 || id == 3 || id == 7 || id == 8">Store Qty</th>
                                <th style="width: 70px; padding-left: 15px; font-size: 13px;">Unit</th>
                                <th *ngIf="isInvQty" style="width: 150px; padding-left: 15px; font-size: 13px;">Inv Qty</th>
                                <th *ngIf="isGNR && isRateView" style="width: 100px; font-size: 13px;">Rate </th>
                                <th *ngIf="id != 2 && id != 7 && id != 8 && batchCnt > 0"style="width: 100px; padding-left: 15px; font-size: 13px; border-top: none;"></th>
                                <th style="width: 200px; padding-left: 15px; font-size: 13px; border-top: none;">Notes </th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let i of items; let l = last; let in = index;">
                                <td style="padding-left: 10px; font-size: 12px; {{l ? 'border-bottom-left-radius: 10px;' : ''}}">{{i.ItemName}}</td>
                                <td style="font-size: 12px;">{{i.ItemCode}}</td>
                                <td><span class="wid60" style="display: inline-block; width: 90%; font-size: 12px;">
                                        <input class="form-control" type="text" (blur)="getTransferQty(in);"
                                            (keyup)="prcisionCheck(i);" [(ngModel)]="i.transferQty"
                                            style="color: {{color ? color : ''}}; text-align: right; height: 25px; position: relative; bottom: 1px; width: 100px !important; background-color: inherit;"></span>
                                </td>
                                
                                <td style="text-align: right; font-size: 12px;" *ngIf="id == 1 || id == 2 || id == 3 || id == 7 || id == 8">
                                    {{i.StoreBatches.length > 0 ? i.StoreItemQty : i.CurrQty}}</td>
                                <!-- <td style="text-align: right;">{{i.StoreBatches.length > 0 ? i.StoreItemQty : i.CurrQty}}</td> -->

                                <td style="padding-left: 15px;font-size: 12px;">{{i.SKU}}</td>
                                <!-- if mitchmatch unit -->
                                <td *ngIf="isInvQty" style="padding-left: 10px;font-size: 12px;">{{i.InvQty ? i.InvQty : ''}}<i (click)="openMultiUnitCal(i, in)" title="Calculate {{title}} Quantity" *ngIf="i.InvQty" style="margin-left: 5px; cursor: pointer; color: #e88421; font-size: 14px;" class="fa fa-solid fa-calculator"></i></td>
                                <td *ngIf="isGNR && isRateView ">
                                    <input class="form-control" type="text" (keyup)="prcisionCheck(i, 2);" [(ngModel)]="i.DefPurchRate"
                                    style="text-align: right; height: 25px; position: relative; bottom: 1px; width: 90% !important; background-color: inherit;">
                                </td>
                                <td *ngIf="id != 2 && id != 7 && id != 8 && batchCnt > 0"  style="padding-left: 15px;font-size: 12px;">
                                    <div *ngIf="i.hasBatches" class="lableBtnOrange inLneBlk brdrRadius3" style="cursor: pointer;" (click)="openBatchSelectionMdl(i, in)">
                                        <i class="{{i.Batches.length > 0 ? 'fa fa-pencil' : 'zmdi zmdi-plus' }}" style="margin-right:5px;"></i>Batches
                                    </div>
                                </td>
                                <td style="padding-left: 15px; font-size: 12px;">
                                    <input type="text" class="form-control" [(ngModel)]="i.Notes"
                                        style="background-color: inherit;font-size: 12px; height: 25px;" maxlength="1000">
                                </td>
                               
                                <td style="width: 20px; cursor: pointer; {{l ? 'border-bottom-right-radius: 10px;' : ''}}"><span class="lableBtnGray brdrRadius3"
                                        (click)="deleteItem(in)" style="border-radius: 15px; padding: 3px 9px;"><i
                                            class="fa fa-trash"></i></span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row" style="margin: 0px; margin-top: 20px; margin-bottom: 20px; margin-left: 5px;">
                <div class="col-md-6 col-lg-6 col-12" *ngIf="id == 1" style="padding: 0px;">
                    <div class="col-md-12 col-lg-12 col-12">
                        Dispatch Details
                    </div>
                    <div class="col-md-12 col-lg-12 col-12">
                        <div class="col-md-12 col-lg-12 col-12" style="padding: 0px; margin-top: 10px;">
                            <div *ngFor="let a of displayArr; let i = index;"
                                style="color: #333; height: 35px; font-size: 14px; {{i % 2 == 0 ? 'background-color: #f8f8f8;' : ''}};">
                                <div class="col-md-5 col-lg-5 col-5"
                                    style="display: inline-block; padding-left: 5px; padding-top: 7px;">{{a.name}} :
                                </div>
                                <div class="col-md-5 col-lg-5 col-5" style="display: inline-block; padding-top: 7px;">
                                    {{a.value}}
                                </div>
                                <div class="col-md-2 col-lg-2 col-2" style="display: inline-block;">
                                    <span class="lableBtnGray" (click)="deleteDisDet(i, a)"
                                        style="border-radius: 10px;"><i class="fa fa-trash"></i></span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 col-lg-12 col-12" style="padding: 0px; margin-top: 10px;"
                            *ngIf="tmpDisptDet.length > 0">
                            <div class="col-md-5 col-lg-5 col-5" style="display: inline-block; padding-left: 0px;">
                                <select class="label darkBlueBadge form-control bgwhite formCtlFltr" [(ngModel)]="disptDetSelect"
                                    style="display: inline-block; font-size: 13px; background: inherit; cursor: pointer;">
                                    <option value="0" selected>Select</option>
                                    <option *ngFor="let d of tmpDisptDet" [ngValue]="d.id">{{d.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-5 col-lg-5 col-5" style="display: inline-block;">
                                <input type="text" class="form-control bgwhite formCtlFltr" placeholder="Value"
                                    [(ngModel)]="disptDetValue">
                            </div>
                            <div class="col-md-2 col-lg-2 col-2" style="display: inline-block;">
                                <span class="lableBtnOrange" (click)="saveDispatchDetails()" style="padding: 2px 10px; font-size: 15px;">  
                                    <i class="fa fa-plus" style="cursor: pointer;"></i>
                                </span>
                               
                            </div>
                        </div>

                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-12" *ngIf="id == 1 && isShowAddr"
                    style="padding: 0px;">
                    <div class="col-md-12 col-lg-12 col-12">
                        Customer Address
                    </div>

                    <div class="col-md-6 col-lg-6 col-10" style="margin-top: 10px; display: inline-block;">
                        <select class="label darkBlueBadge form-control bgwhite bdrrd10" [(ngModel)]="selCustAddr"
                            (ngModelChange)="createCustAddr()"
                            style="display: inline-block; font-size: 13px; background: inherit; cursor: pointer;">
                            <option value="0" selected>Select</option>
                            <option *ngFor="let c of custAddress" value="{{c.AddrID}}">{{c.AddrName}} ({{c.City}}) {{
                                c.GSTIN ? '- ' + c.GSTIN : '' }} </option>
                        </select>
                    </div>

                    <div class="col-md-2 col-lg-2 col-2" style="display: inline-block;">
                        <i class="fa fa-plus" (click)="addNewCustomerAddr()"
                            style="position: relative; top: 5px; color: #E88421; cursor: pointer;"
                            title="Add new address"></i>
                    </div>

                </div>

                <div class="col-md-12 col-lg-12 col-12" style="padding: 0px; margin-top: 15px;">
                    <div class="col-md-12 col-lg-12 col-12" style="margin-bottom: 5px; font-size: 14px; display: none;">
                        Add Notes :
                    </div>
                    <div class="col-md-12 col-lg-12 col-12 margBtm40">
                        <textarea class="form-control textArea brdrRadius3" [(ngModel)]="xnNotes" rows="3" style="width: 100%;" maxlength="1000"
                            id="notes" placeholder="Notes"></textarea>
                    </div>
                </div>
            </div>

            <div class="row webView" style="margin: 0px;">
                <div class="col-md-12 col-lg-12 col-12" style="margin-top: 10px; width: 100%; text-align: left; padding-left: 20px;">
                    <div>
                        <div class="btn-darkBlue brdrRadius3" style="padding: 4px 12px 4px; font-size: 13px;" (click)="transfer()"><i
                                class="fa fa-check" aria-hidden="true"></i> Enter {{ id == 7 || id == 8 ? 'Transaction' : title }}</div>
                    </div>
                    <div style="margin-top: 5px; margin-left: 10px;">
                        <div style="display: inline-block; margin-right: 10px;font-size: 13px;"><span
                                style="font-weight: bold;">{{transferQty}}</span> Qty.</div>
                        <div style="display: inline-block; font-size: 13px;"><span
                                style="font-weight: bold;">{{items.length}}</span> {{ items.length == 0 || items.length
                            == 1 ? 'Item' : 'Items'}}</div>
                    </div>
                </div>
            </div>

            <div class="row mobView">
                <div class="bottom col-md-12 col-lg-12 col-12"
                    style="margin-top: 10px; position: fixed; width: 100%; text-align: center; background-color: #FFF;">
                    <div>
                        <div class="btn darkBlueButton mrgRgt220 font13" (click)="transfer()"><i class="fa fa-check"
                                aria-hidden="true"></i> Enter {{ id == 7 || id == 8 ? 'Transaction' : title }}</div>
                    </div>
                    <div class="mrgRgt220" style="margin-top: 5px;">
                        <div style="display: inline-block; margin-right: 10px;font-size: 13px;"><span
                                style="font-weight: bold;">{{transferQty}}</span> Qty.</div>
                        <div style="display: inline-block;font-size: 13px;"><span
                                style="font-weight: bold;">{{items.length}}</span> 
                            {{ items.length == 0 || items.length == 1 ? 'Item' : 'Items'}}
                        </div>
                    </div>
                </div>
            </div>

        </div>        
        <div class="col-md-5 col-lg-5 col-12"
            style="padding-left: 20px; padding-right: 30px; padding-bottom: 15px; display: inline-block; display: none;">
            <div class="col-md-12 col-lg-12 col-12"
                style="box-shadow: 0 5px 8px rgb(0 0 0 / 20%); background-color: #4caf5016 !important; padding: 0px; border-radius: 25px;">
                <div
                    style="background-image: url(../../../assets/images/feedback.jpg); width: 100%; height: 200px; background-position: center; background-size: cover; border-top-left-radius: 25px; border-top-right-radius: 25px;">
                </div>

                <div class="col-md-12 col-lg-12 col-12" style="padding: 20px 15px;">
                    <div class="greenText" style="font-size: 22px;"> <i class="fa fa-check greenText"
                            style="font-size: 20px; margin-right: 7px;"></i> Order Status Updates</div>
                    <div class="greenText" style="font-size: 13px;">Empower customers; save time from follow-ups</div>

                    <div class="greenText" style="font-size: 22px; margin-top: 30px;"> <i class="fa fa-check greenText"
                            style="font-size: 20px; margin-right: 7px;"></i> Timely Delivery</div>
                    <div class="greenText" style="font-size: 13px;">Track sales commitments; deliver orders punctually
                    </div>

                    <div class="greenText" style="font-size: 22px; margin-top: 30px;"> <i class="fa fa-check greenText"
                            style="font-size: 20px; margin-right: 7px;"></i> Support Ticketing</div>
                    <div class="greenText" style="font-size: 13px;">Resolve support requests; win customer loyalty</div>

                    <div class="greenText" style="font-size: 22px; margin-top: 30px;"> <i class="fa fa-check greenText"
                            style="font-size: 20px; margin-right: 7px;"></i> Effective Feedback</div>
                    <div class="greenText" style="font-size: 13px;">Listen & learn from the customer!</div>
                </div>
            </div>
        </div>
    </div>


</div>

<!-- Item Modal -->
<ng-template #selectItem let-modal>
    <app-multiple-select-item></app-multiple-select-item>
</ng-template>

<!-- Store Selection Modal -->
<ng-template #storeSelect let-modal>
    <app-select-store></app-select-store>
</ng-template>
<!-- 
<ng-template #selectItem let-modal>
    <app-multi-unit-calculator.component></app-multiple-selectmulti-unit-calculator>
</ng-template> -->

<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>
